/**
 * Display label for a site-level VMS field on Site About. The label comes
 * from the API's `extra_fields` entry (admin's own wording) and is normally
 * shown as-is; the cases below patch older admin labels per integration.
 */
export const getVmsDisplayLabel = (
  label: string,
  integrationTypeName?: string | null
) => {
  const integration = integrationTypeName?.toLowerCase();

  if (label === "Server ID" && integration === "exacq") {
    return "Exacq Server ID";
  }

  // Genetec's event_server_ip is the Media Gateway host; admin labels it
  // that way, the legacy label (vMSvariablesArray) still says Event Server IP.
  if (label === "Event Server IP" && integration === "genetec") {
    return "Media Gateway Host";
  }

  return label;
};
